import { all, takeEvery, put, call, fork, select } from 'redux-saga/effects';
import { notification } from '@iso/components';
import UserApi from '../../library/helpers/userManagementHelper';
import {getCookie} from '@iso/lib/helpers/session';
import {onboardError, EN_translation, NL_translation, FR_translation } from '../../config'

import actions from './action';
export function* userOnboardRequest() {
  yield takeEvery(actions.USER_ONBOARD, function* ({ payload }) {
    const selectedLanguage = yield select(state => state.LanguageSwitcher.language.languageId);
     const result = yield call(UserApi.onboard, payload.dataObj);
    // console.log("userApi sagaresult",result , selectedLanguage);
     if (!result.success) {
      if((result.message == onboardError.accMailMobNRIN) || (result.message == onboardError.accMailMob) || (result.message==onboardError.accMailNRIN) || (result.message==onboardError.accMobNRIN )|| (result.message == onboardError.accMail) || (result.message ==onboardError.accMob) || (result.message == onboardError.accNRIN)){
        notification('error', 
          selectedLanguage && selectedLanguage === "dutch" ? NL_translation.accExists :
          selectedLanguage === "french" ? FR_translation.accExists : EN_translation.accExists
        );
      }
    } else {
      // notification('success', result.message);
    }
    yield put(
      actions.useraApiSuccess(
        result.data,
        result.message,
        result.success
        )
    );
     
    
  });
}
export function* userAddRequest() {
  yield takeEvery(actions.USER_ADD, function* ({ payload }) {
     const result = yield call(UserApi.add, payload.dataObj);
    // console.log("userApi sagaresult",result );
     if (!result.success) {
      notification('error', result.message);
    } else {
      // notification('success', result.message);
      if(payload.redirectKey==1){
        payload.history.push(`/dashboard/admin/users/admin-user-list`);
      }

    }
    yield put(
      actions.useraApiSuccess(
        result.data,
        result.message,
        result.success
        )
    );
  });
}
export function* userListRequest() {
  yield takeEvery(actions.USER_LIST, function* ({ payload }) {
    // console.log('userLisrtt',payload);
     const result = yield call(UserApi.list, payload.readFilter,payload.page);
    //  console.log('result user list',result);
      if (!result.success) {
      notification('error', result.message);
    }  
    yield put(
      actions.useraApiSuccess(
        result.data,
        result.message,
        result.success
        )
    );
  });
}
export function* investerListRequest() {
  yield takeEvery(actions.INVESTER_LIST, function* ({ payload }) {
    // console.log('userLisrtt',payload);
     const result = yield call(UserApi.investerList, payload.readFilter,payload.page);
    //  console.log('result user list',result);
      if (!result.success) {
      notification('error', result.message);
    }  
    yield put(
      actions.useraApiSuccess(
        result.data,
        result.message,
        result.success
        )
    );
  });
}
 
export function* userUpdateRequest() {
  yield takeEvery(actions.USER_UPDATE , function* ({ payload }) {
    // console.log('payload', payload)
    // console.log('userupdate',payload.dataObj);
     const result = yield call(UserApi.update, payload.dataObj);
 
      if (!result.success) {
      notification('error', result.message);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
   
    } else {
      if(payload.redirectKey == 1){
        notification('success', result.message);
        setTimeout(() => {
        window.location.reload();
        }, 500);
      //  if(role=='client'){
      //   payload.history.push(`/investor-dashboard`);
      //  }else{
        // window.location.href = `/investor-dashboard?id=${result.data._id}`
        //  payload.history.push(`/investor-dashboard?id=${result.data._id}`, { id: result.data._id });
      // }
    } else if(payload.redirectKey == 3){
      
      payload.history.push('/dashboard/cdd-dashboard');
}
    else if(payload.redirectKey==2){
       
            payload.history.push('/dashboard/admin/users/admin-user-list');
     }
      // notification('success', result.message);
    }
    yield put(
      actions.useraApiSuccess(
        result.data,
        result.message,
        result.success
        )
    );
  });
}
export function* userGetByIdRequest() {
  yield takeEvery(actions.USER_FETCH_ID, function* ({ payload }) {
     const result = yield call(UserApi.findById, payload.listid._id);
      if (!result.success) {
      notification('error', result.message);
    } else {
      // notification('success', result.message);
    }
    yield put(
      actions.userListById(
        result.data,
        result.message,
        result.success
        )
    );
  });
}
export function* cddListRequest() {
  yield takeEvery(actions.CDD_LIST, function* ({ payload }) {
    // console.log('userLisrtt',payload);
     const result = yield call(UserApi.cddList, payload.readFilter,payload.page);
    //  console.log('result user list',result);
      if (!result.success) {
      notification('error', result.message);
    }  
    yield put(
      actions.useraApiSuccess(
        result.data,
        result.message,
        result.success
        )
    );
  });
}
export function* cddBulk_UpdateRequest() {
  yield takeEvery(actions.CDD_BULK_UPDATE, function* ({ payload }) {
    // console.log('userBulkUpdate',payload.userPojo);
     const result = yield call(UserApi.cdd_BulkUpdate_List, payload.userPojo);
    //  console.log('result', result)
      if (!result.success) {
      notification('error', result.message);
    } else {
      notification('success', result.message);
    }
  });
}
export function* compCddListRequest() {
  yield takeEvery(actions.COMP_CDD_LIST, function* ({ payload }) {
    // console.log('userLisrtt',payload);
     const result = yield call(UserApi.compCddList, payload.readFilter,payload.page);
    //  console.log('result user list',result);
      if (!result.success) {
      notification('error', result.message);
    }  
    yield put(
      actions.compUserApiSuccess(
        result.data,
        result.message,
        result.success
        )
    );
  });
}

export default function* rootSaga() {
  yield all([
    fork(userAddRequest), 
    fork(userUpdateRequest),
    fork(userOnboardRequest),
    fork(userListRequest),
    fork(investerListRequest),
    fork(userGetByIdRequest),
    fork(cddListRequest),
    fork(cddBulk_UpdateRequest),
    fork(compCddListRequest),
   ]);
}

